import React, { useMemo } from "react"
import { Helmet } from "react-helmet-async"
import { useVenue } from "providers/venue"
import { first, get } from "lodash"
import { useTranslation } from "providers/i18n/useTranslation"

export const Head = (props) => {
  const { title = "", description = "", suffixTitle } = props
  const { venues } = useVenue()
  const { t } = useTranslation()
  const defaultSuffixTitle = useMemo(
    () => ` - ${t(get(first(venues), "properties.name", "Venue Indoor Map"))}`,
    [venues, t]
  )

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{`${title}${suffixTitle || defaultSuffixTitle}`}</title>
      <meta name="description" content={description} />
      {/* End standard metadata tags */}
    </Helmet>
  )
}
